import React, { useEffect,useState } from "react";
import format from "date-fns/format";
import classnames from "classnames";
import { connect } from "react-redux";
import { withRouter } from "react-router";


import * as actions from "../../../../store/actions";
import { VALIDATE_TEMPLATE } from "../../../../store/actions/actionTypes";

import Modals from "../../../../components/uiElements/popupModal/modal";
import Button from "../../../../components/formElements/button/Button";

import CustomTextArea from "../../../../components/formElements/customTextArea/CustomTextArea";
import NoteModal from "../../../../components/uiElements/modal/NoteModel";

const EditTemplate = ({
  form,
  isOpen,
  closeModal,
  editMode,
  pid,
  editTemplateById,
  templates,
  setTemplateData,
  getTemplateById,
  match,
  clearEditMode,
  addNote,
  setComp,
  setValue,
  setVal,
  getAllPatientNotes
}) => {
  const id = match?.params?.id;
  const [page,setPage]=useState(1)
  const [tem, setTem] = useState(false);

  useEffect(() => {
  if (form && form.templatesValid) {
    editTemplateById(pid, () => {
    });
  }

  form.templatesValid = false;
  // eslint-disable-next-line
}, [form]);

useEffect(() => {
  getTemplateById(pid);
  // eslint-disable-next-line
}, []);

useEffect(() => {
  return () => {
    clearEditMode();
  };
  // eslint-disable-next-line
}, []);

  return (
    <>
     {tem && (
        <NoteModal
        isOpen={tem}
        onLock={() =>
          addNote(() => {
            closeModal()
            setValue(true)
            setVal(true)
            setComp(false)
            setPage(1)
            getAllPatientNotes(id, "", page)
            })
        }
        onSaveAsTemplate={() => {
        editTemplateById(pid)
          addNote()
          closeModal()
          setValue(true)
          setVal(true)
          setComp(false)
          setPage(1)
          getAllPatientNotes(id, "", page)
        }}
        closeModal={() => setTem(!tem)}
      />
      )}
    
      <Modals
        isOpen={isOpen}
        onRequestClose={() => closeModal}
        styles={{
          content: {
            minWidth: "55%",
            maxWidth: "80%",
            maxHeight: "90",
            width: "60%",
            height: "auto",
          },
        }}
      >
        <>
          <button
            onClick={closeModal}
            className="close modalCloseBtn1"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="row">
        <div className="col-md-6 d-flex align-items-center text-dark">
          <p className="h3">
            <span className="ml-1 h4 text-dark">
              {editMode ? "Edit " : ""} Note
            </span>
          </p>
        </div>

        <div className="col-md-4 ml-auto editnotebtn">
          {editMode ? (
            ""
          ) : (
            <div className="d-flex justify-content-between align-items-center mt-2 px-2">
             
            </div>
          )}
        </div>
      </div>
      <div
        className={classnames(
          "note-template-container",
          editMode ? "" : "disable"
        )}
      >
        <>
          <div style={{ width: "100%" }}>
            <CustomTextArea
              label="Note Name"
              value={templates?.note_name || ""}
              className="mycontentdivMain"
              error={form.note_name}
              onChange={val => setTemplateData({ note_name: val })}
            />
          </div>
          <div style={{ width: "100%" }}>
            <CustomTextArea
              label="Chief Complaint"
              value={templates?.chief_complaint || ""}
              className="mycontentdivMain"
              error={form.chief_complaint}
              onChange={val => setTemplateData({ chief_complaint: val })}
            />
          </div>
        </>
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Notes"
            value={templates?.notes}
            className="mycontentdivMain "
            onChange={val => setTemplateData({ notes: val })}
            error={form.notes}
          />
        </div>

        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Assessment"
            value={templates?.assessment || ""}
            className="mycontentdivMain"
            error={form.assessment}
            onChange={val => setTemplateData({ assessment: val })}
          />
        </div>
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Plan"
            value={templates?.plan || ""}
            className="mycontentdivMain"
            error={form.plan}
            onChange={val => setTemplateData({ plan: val })}
          />
        </div>
        {editMode ? (
          <div className="col-md-4 d-flex justify-content-between align-items-center mt-2 px-2">
            <Button
              onClick={() => {
                setTem(true)
              }}
              label="Save"
              className="mr-3"
            />
            <Button
              type="outline"
              label={"Cancel"}
              onClick={() => {
                closeModal()
              }}
              className="btn-block"
            />
          </div>
        ) : (
          ""
        )}
      </div>
        </>
      </Modals>
    </>
  );
};
const mapStoreToProps = ({ dashboard, validation }) => ({
  templates: dashboard.templates.currentData,
  form: validation.data,
  editMode: dashboard.templates.editMode,
  currentData: dashboard?.patients?.currentData,
});
const mapDispatchToProps = dispatch => ({
  validateData: templates =>
    dispatch(actions.validateData(VALIDATE_TEMPLATE, templates)),
  getTemplateById: id => dispatch(actions.getTemplateById(id)),
  setTemplateData: Data => dispatch(actions.setTemplateData(Data)),
  clearTemplateData: () => dispatch(actions.clearTemplateData()),
  editTemplateById: (id, cb) => dispatch(actions.editTemplateById(id, cb)),
  setEditMode: () => dispatch(actions.setEditMode()),
  clearEditMode: () => dispatch(actions.clearEditMode()),
  deleteTemplateById: (tempID, cb) =>
    dispatch(actions.deleteTemplateById(tempID, cb)),
  addNote: (cd,pid) =>
    dispatch(actions.addNote(cd,pid)),
  getAllPatientNotes: (id, q, page) =>
    dispatch(actions.getAllPatientNotes(id, q, page)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(EditTemplate)
);